import Summary from "./SummaryContainer";

export default {
  Summary
};
